import React from 'react';
import { useSelector } from 'react-redux';
import realisticImg from '../../../../../assests/realisticIsrael/realisticImg.png';

import classes from './RealisticIsraelText.module.css';

const RealisticIsraelText = ({ description, link=null, linkText }) => {

    const { texts } = useSelector(state => state.translate);


    return (
        <div className={classes.RealisticIsraelText}>
            <div className={classes.TextSide}>
                <div className={classes.NewBadge}>{`${texts.new ?? ""}!`}</div>
                <div className={classes.TitleContainer}>
                    <p className={classes.TitleText}>{texts.realisticIsraelTitle}</p>
                    <p className={classes.TitleTrans}>{texts.itsRealistic}</p>
                </div>
                <div className={classes.DescriptionWrapper}>
                    <p className={classes.Description}>{description}</p>
                    <p className={classes.Note}>{(texts.realisticIsraelNote)}</p>
                    {linkText && <a className={classes.link} href={link} target="_blank" rel="noreferrer">{linkText}</a>}
                </div>
            </div>

            <div className={classes.ImageSide}>
                <img src={realisticImg} alt={texts.realisticIsraelImageAlt} className={classes.RealisticImage} />
            </div>
        </div>
    )
}
export default RealisticIsraelText;